export function extract<T, X extends keyof T>(data: T, ...keys: X[]): Pick<T, X> {
  return keys.reduce((prev, cur) => {
    prev[cur] = data[cur]
    return prev
  }, Object.create(null))
}
